<template>
  <div>
    <div class="container">

      <div
        class="box"
        @click="setActiveComponent('UserCalendar')"
        :class="{ active: currentComponent === 'UserCalendar' }"
      >
        <div class="icon">
          <img class="icon" src="./icons/randevular.svg" :alt="$t('randevu.advanced_menu.appointments_alt')" />
        </div>
        <span>{{ $t('randevu.advanced_menu.appointments') }}</span>
      </div> 

      <div
        class="box"
        @click="setActiveComponent('CustomersPanel')"
        :class="{ active: currentComponent === 'CustomersPanel' }"
      >
        <div class="icon">
          <img class="icon" src="./icons/musteriler.svg" :alt="$t('randevu.advanced_menu.customers_alt')" />
        </div>
        <span>{{ $t('randevu.advanced_menu.customers') }}</span>
      </div>

      <div
        class="box"
        @click="setActiveComponent('ProductPanel')"
        :class="{ active: currentComponent === 'ProductPanel' }"
      >
        <div class="icon">
          <img class="icon" src="./icons/hizmetler.svg" :alt="$t('randevu.advanced_menu.services_alt')" />
        </div>
        <span>{{ $t('randevu.advanced_menu.services') }}</span>
      </div>

      <div
        class="box"
        @click="setActiveComponent('UzmanlarPanel')"
        :class="{ active: currentComponent === 'UzmanlarPanel' }"
      >
        <div class="icon">
          <img class="icon" src="./icons/uzmanlar.svg" :alt="$t('randevu.advanced_menu.experts_alt')" />
        </div>
        <span>{{ $t('randevu.advanced_menu.experts') }}</span>
      </div> 

      <div
        class="box"
        @click="setActiveComponent('MyStats')"
        :class="{ active: currentComponent === 'MyStats' }"
      >
        <div class="icon">
          <img class="icon" src="./icons/stats.svg" :alt="$t('randevu.advanced_menu.stats_alt')" />
        </div>
        <span>{{ $t('randevu.advanced_menu.stats') }}</span>
      </div>



    </div>
<div class="contentmain">
  <div class="content" v-if="currentComponent">
      <component :is="currentComponent" />
    </div>
</div>

  </div>
</template>

<script>
import CustomersPanel from '../application/advanced/CustomersPanel.vue'
import ProductPanel from './advanced/MyServices.vue'
import UzmanlarPanel from './advanced/MyExperts.vue'
import UserCalendar from './UserCalendar.vue'
import MyStats from './stats/MyStats.vue'

export default {
  components: {
    CustomersPanel,
    ProductPanel,
    UzmanlarPanel,
    UserCalendar,
    MyStats
  },
  data() {
    return {
      currentComponent: "UserCalendar"
    }
  },
  methods: {
    setActiveComponent(component) {
      this.currentComponent =
        this.currentComponent === component ? null : component
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.contentmain {
  display: flex;
  align-items: center;
  justify-content: center;

}
.content {
  margin-bottom: 1rem;
  width: 100%;
  max-width: 1080px;
}

.box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  padding: 0 1em;
  min-height: 3em;
  border-radius: 2px;
  text-decoration: none;
  background: linear-gradient(45deg, #020202, #080808, #020202);
  color: #b5b5b5;
  font-size: 1.2em;
  font-weight: 300;
  transition: transform 0.2s ease, box-shadow 0.3s ease, color 0.2s ease;
  cursor: pointer;
  border-bottom: 3px solid transparent;
}

.box:hover {
  transform: scale(1.05);
  color: white;
  box-shadow: 0 5px 12px rgba(0, 104, 42, 0.2);
}

.box.active {
  border-bottom: 1px solid #065959;
  color: white;
}

.icon {
  min-width: 2em;
  max-height: 1.5em;
  opacity: 0.8;
  filter: grayscale(50%);
}

.box:hover .icon {
  opacity: 1;
  filter: grayscale(0%);
}

.box.active .icon {
  opacity: 1;
  filter: grayscale(0%);
}

@media (max-width: 768px) {
  .container {
    flex-wrap: wrap;
  }
  .box {
    color: #b5b5b5;
    font-size: 1em;
    font-weight: 300;
  }
}
</style>
